import * as t from 'app/actions/finances';

export const initState = {
  loading: true,
  data: {},
};

function my(state = initState, { type, payload }) {
  switch (type) {
    case t.FINANCES_RESET:
      return initState;

    case t.FINANCES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case t.FINANCES_FAIL:
      return {
        ...state,
        loading: false,
      };

    case t.FINANCES_SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false,
      };

    default:
      return state;
  }
}

export default my;
